import Moment from 'moment';

/**
 * Given an anchor date and an operational value of 'add', 'subtract' or 'null', returns a
 * Moment JS calculated date from the Anchor Date.
 *
 * @param { string } anchorDate - date of either general on sale or event date
 * @param { string } operator - add, subtract, or null
 * @param { number } months
 * @param { number } weeks
 * @param { number } days -
 * @param { number } hours -
 * @param { number } minutes
 * @param { string } specificTime - time picker value
 * @returns { object } A Moment JS object.
 */
const calculateRelativeDate = (
  anchorDate,
  operator,
  months,
  weeks,
  days,
  hours,
  minutes,
  specificTime
) => {
  let calculatedDate;
  if (operator === 'add') {
    calculatedDate = Moment(anchorDate)
      .add(months * 28, 'days')
      .add(weeks * 7, 'days')
      .add(days, 'days');
    if (specificTime) {
      calculatedDate.set({
        hour: Number(specificTime.split(':')[0]),
        minute: Number(specificTime.split(':')[1]),
      });
    } else {
      calculatedDate.add(hours, 'hours').add(minutes, 'minutes');
    }
  } else if (operator === 'subtract') {
    calculatedDate = Moment(anchorDate)
      .subtract(months * 28, 'days')
      .subtract(weeks * 7, 'days')
      .subtract(days, 'days');
    if (specificTime) {
      calculatedDate.set({
        hour: Number(specificTime.split(':')[0]),
        minute: Number(specificTime.split(':')[1]),
      });
    } else {
      calculatedDate.subtract(hours, 'hours').subtract(minutes, 'minutes');
    }
  } else {
    // On Event Start or On General Onsale
    if (!specificTime) {
      calculatedDate = Moment(anchorDate);
    } else {
      calculatedDate = Moment(anchorDate).set({
        hour: Number(specificTime.split(':')[0]),
        minute: Number(specificTime.split(':')[1]),
      });
    }
  }
  return Moment(calculatedDate);
};

export default calculateRelativeDate;



// WEBPACK FOOTER //
// ./src/common/lib/CalculateRelativeDate.js